const alfaPartners = url => `<script>
(function(d, w, nav, sc) {
  var isPixelSent = false;
  var utmSource = new URL(window.location.href).searchParams.get('utm_source');

  if(!utmSource || !utmSource.includes('alfapartners')) return;

  dataLayer.push({ event: 'alfapartners' });

  function serialize(obj) {
    return Object.keys(obj)
      .map(function(key) {
        return [key, obj[key]].join('=');
      })
      .join('&');
  }

  function getCookie(name) {
    var matches = d.cookie.match(new RegExp('(?:^|; )' + name.replace(/([.$?*|{}()[]\\/+^])/g, '\\$1') + '=([^;]*)'));
    return matches ? decodeURIComponent(matches[1]) : '';
  }

  function createPixel(product = '') {
    if (isPixelSent) return;

    var query = {};
    var sessionStart = getCookie('gtm-session-start') || new Date().getTime();
    var cid = getCookie('_ym_uid');

    try {
      query.platform_id = getCookie('platformId') || getCookie('GTM_platformId') || 'alfasite';
      query.url = '${url}';
      query.clientid = getCookie('_ym_uid');
      query.sessionid = [sessionStart, cid].join('.');
      query.product = product;
    } catch (e) {}

    var path = 'https://alfapartners.alfabank.ru/pixel/click/';
    var qs = serialize(query);
    var img = new Image();
    img.src = [path, '?', qs].join('');
    img.style = 'position:absolute; left:-9999px;'

    isPixelSent = true;
  }

  function subscribeProduct(dlvalues) {
    if (!dlvalues.product) return;

    createPixel(dlvalues.product);
  }

  if (window.DATA_LAYER) { window.DATA_LAYER.subscribe(subscribeProduct) }

  window.onunload = function () { createPixel() };
})(document, window, navigator, screen);
</script>
`;

module.exports = {
    alfaPartners
};
